import React from "react";
import PageNotFound from "templates/pages/PageNotFound";

const NotFoundPageTemplate = () => {
  return <PageNotFound />;
};

export default NotFoundPageTemplate;
